import React from 'react';

import { flagStyles } from '../settings';

const SvgTF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5136px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTF;
